// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"183":"5b2c03cd","684":"333ca60c"}[chunkId] + ".css";
};